// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"158c9e26","172":"981c65dd","599":"7d3d6a9e","641":"b73acfed","725":"b4ce1551"}[chunkId] + ".chunk.js";
};